<template>
  <div>
    <div class="coverBanner">
      <div class="image">
        <img
          class="img-fluid desktop"
          src="@/assets/images/banner/coverBanner.jpg"
          alt=""
        />
        <img
          class="responsive"
          src="@/assets/images/banner/coverBanner-responsive.jpg"
          alt=""
        />
        <div class="zain-logo">
          <a href="#">
            <img class="img-fluid" src="@/assets/images/zain-logo.png" alt="" />
          </a>
        </div>
        <div class="content">
          <h1>
            <span>WOMEN IN</span>
            <span>TECHNOLOGY</span>
          </h1>
          <h2>
            <span>BRIDGING THE GENDER</span>
            <span>GAP IN STEM FIELDS</span>
          </h2>
          <hr />
          <p class="report-desc">THOUGHT LEADERSHIP REPORT 2021</p>
        </div>
      </div>
    </div>

    <div id="loader-wrapper">
      <div id="loader">
        <img img fluid src="@/assets/images/zain.gif" alt="" />
      </div>
      <div class="loader-section section-left"></div>
      <div class="loader-section section-right"></div>
    </div>

    <section class="tableContents">
      <tableOfContents></tableOfContents>
    </section>
    <modal></modal>
  </div>
</template>
<script>
import tableOfContents from "@/components/common/tableOfContents.vue";
import modal from "@/components/common/reportModal.vue";
import { gsap } from "gsap";
export default {
  components: {
    tableOfContents,
    modal
  },
  mounted() {
    setTimeout(() => {
      document.body.classList.add("loaded");
      this.animation();
    }, 2000);
    setTimeout(
      () => document.querySelector("#reportModal").classList.add("show"),
      6000
    );
  },

  methods: {
    animation() {
      let tl = gsap.timeline({
        paused: true
      });
      let title = "h1 span";
      let subtitle = "h2 span";
      let report = ".report-desc";
      tl.to(".zain-logo", { autoAlpha: 1, y: 0, ease: "power2.ease" }, "+=0.1");
      //tl.from(title, {duration: 0.8, opacity:0, scale:0, y:80, rotationX:180, transformOrigin:"0% 50% -50",  ease:"back", stagger: 0.01}, "+=0");
      tl.fromTo(
        title,
        {
          opacity: 0,
          rotationX: -120,
          force3D: true,
          transformOrigin: "top center -150"
        },
        {
          duration: 0.5,
          opacity: 1,
          rotationX: 0,
          transformOrigin: "top center 0",
          stagger: 0.2
        }
      );
      // tl.to(title, {x:0, duration: 1.5, stagger:0.5, ease: "elastic.out(1.5, 0.75)"});
      tl.to(
        subtitle,
        { y: 0, duration: 0.75, ease: "power1.out", stagger: 0.2 },
        "-=0.3"
      );
      tl.to("hr", { width: "100%", duration: 1, ease: "power1.out" });
      tl.to(
        report,
        { opacity: 1, y: 0, duration: 0.6, ease: "power1.out" },
        "-=0.5"
      );
      tl.play();

      let tlreverse = gsap.timeline();
      tlreverse.to(".content", {
        scrollTrigger: {
          trigger: "tableContents",
          start: "top top",
          end: "bottom 90%",
          markers: false,
          scrub: true
        },
        opacity: 0,
        duration: 0.5
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.zain-logo {
  opacity: 0;
  transform: translateY(-100%);
  max-width: 20%;
  position: absolute;
  top: 40px;
  left: 80px;

  @media screen and (max-width: 991px) {
    top: 80px;
    max-width: 200px;
  }
  @media screen and (max-width: 575px) {
    top: 80px;
    left: 15px;
    max-width: 170px;
  }
}
.coverBanner {
  position: relative;
  height: 100vh;
  overflow: hidden;
   background-color: #4c505b;
  @media screen and (min-width:576px) and (max-width:767px){
      height:490px;
    }
  p {
    font-weight: 700;
  }
  .image {
    padding: 0px;
    height: 100vh;
    @media screen and (min-width:576px) and (max-width:767px){
      height:490px;
    }
    img.desktop {
      height: 100%;
      display: block;
      margin-right: 0;
      margin-left: auto;
      @media screen and (max-width: 1024px) {
        &.desktop {
          display: none;
        }
        &.responsive {
          display: block;
        }
      }
    }
    img.responsive {
      height: 100%;
      max-width: 100%;
      margin-right: 0;
      margin-left: auto;
      display: none;
      @media screen and (max-width: 1024px) {
        display: block;
      }
      @media screen and (max-width: 575px) {
        object-fit: cover;
        object-position: right center;
      }
    }
  }
  h1 {
    font-size: 96px;
    margin-bottom: 40px;
    font-weight: 700;
    overflow: hidden;
    @media screen and (max-width: 1400px) {
      font-size: 75px;
      margin-bottom: 30px;
    }
    @media screen and (max-width: 991px) {
      font-size: 60px;
    }
    @media screen and (max-width: 767px) {
      font-size: 40px;
      margin-bottom: 20px;
    }
    @media screen and (max-width: 575px) {
      font-size: 30px;
    }
    span {
      display: block;
      opacity: 0;
      // transform: translateX(-100%);
    }
  }
  .content {
    position: absolute;
    top: 250px;
    left: 80px;
    color: #fff;
    @media screen and (max-width: 1400px) {
      top: 200px;
    }
    h2 {
      position: relative;
      overflow: hidden;
      height: 120px;
      font-size: 4rem;
      border-bottom: 1px solid #fff;
      padding-bottom: 4px;
      border-bottom: 0px;
      margin-bottom: 0px;
      padding-bottom: 1rem;
      @media screen and (max-width: 1400px) {
        font-size: 3.3rem;
      }
      @media screen and (max-width: 991px) {
        font-size: 3rem;
      }
      @media screen and (max-width: 767px) {
        font-size: 2.5rem;
        height: 70px;
      }
      @media screen and (max-width: 575px) {
        font-size: 1.5rem;
        height: 50px;
      }
      span {
        display: block;
        transform: translateY(250%);
      }
    }
    hr {
      border-color: #fff;
      width: 0px;
      transform-origin: 0px;
    }
  }
  .report-desc {
    opacity: 0;
    transform: translateY(50%);
  }
  @media screen and (max-width: 767px) {
    .content {
      left: 85px;
      top: 200px;
    }
  }
  @media screen and (max-width: 575px) {
    .content {
      left: 15px;
      top: 180px;
    }
  }
}
/deep/ {
  @media screen and (max-width: 767px) {
    section {
      padding-top: 0 !important;
    }
  }
}

#loader-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1003;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}
#loader {
  display: block;
  position: relative;
  left: 0;
  top: 0;
  width: 300px;
  transform: none;
  z-index: 1001;
}
#loader-wrapper .loader-section {
  position: fixed;
  top: 0;
  width: 51%;
  height: 100%;
  background: #fff;
  z-index: 1000;
}
#loader-wrapper .loader-section.section-left {
  left: 0;
}
#loader-wrapper .loader-section.section-right {
  right: 0;
}
.loaded #loader-wrapper .loader-section.section-left {
  -webkit-transform: translateX(-100%);
  -ms-transform: translateX(-100%);
  transform: translateX(-100%);
  -webkit-transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.loaded #loader-wrapper .loader-section.section-right {
  -webkit-transform: translateX(100%);
  -ms-transform: translateX(100%);
  transform: translateX(100%);
  -webkit-transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.loaded #loader {
  opacity: 0;
  -webkit-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
}
.loaded #loader-wrapper {
  visibility: hidden;
  -webkit-transform: translateY(-100%);
  -ms-transform: translateY(-100%);
  transform: translateY(-100%);
  -webkit-transition: all 0.3s 1s ease-out;
  transition: all 0.3s 1s ease-out;
}
#loader img {
  max-width: 100%;
}
.modal-open {
  overflow: hidden;
}
</style>
